import MoreVertIcon from "@mui/icons-material/MoreVert";

export const dataCab = {
  header: [
    {
      label: "NO",
      key: "id",
    },
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Customer Seat",
      key: "seat",
    },
    {
      label: "",
      key: "icon",
    },
  ],
  body: [
    {
      id: "1",
      type: "Suv",
      seat: "4 seat",
      icon: <MoreVertIcon />,
    },
  ],
};

export const cabDetails = (data,vehicelPriority) => [
  {
    required: true,
    type: 'vehicleImg',
    name: "avtar",
    label: "Vehicle Image",
  },
  {
    placeholder: "Category name",
    required: true,
    type: "text",
    name: "category",
    label: "Category Name",
    star: "*",
    value: data?.carType || "",
    validation: {
    pattern: {
      value: /^[A-Za-z0-9 ]+$/,
      message: "Special characters are not allowed",
    }
  }
  },
  {
    placeholder: "Customer seat",
    required: true,
    type: "Number",
    name: "customerSeat",
    label: "Customer Seat",
    star: "*",
    value: data?.seater || "",
  },
  {
    placeholder: "Add Facilities",
    type: "text",
    name: "facilities",
    label: "Facilities",
    autoComplete: true,
    value: data?.seater || "",
  },
  {
    options:vehicelPriority,
    type:'text',
    placeholder: 'Select Priority',
    required: true,
    name: 'priority',
    label: 'Select Priority',
    star: '*',
  },
  {
    placeholder: "Add Description",
    required: false,
    type: "text",
    name: "description",
    label: "Description",
    value: data?.description || "",
  }
];
